import dayjs from 'dayjs';
import capitalize from 'lodash/capitalize';
import { useMemo } from 'react';
import InfoDetailsSet from '@/modules/issuer-dashboard/components/InfoDetailsSet.tsx';
import { getKycFallbackMessage } from '@/modules/issuer-dashboard/components/holder-tabs/kycFallbackMessage.ts';
import { InfoCard } from 'ui';
import { BronIDVerificationStatusResponse, ShareholderExtendResponse } from 'api';

interface KycDetailsProps {
  kycLoading: boolean;
  isKycDoneOutsideBronId: boolean;
  kycData?: BronIDVerificationStatusResponse;
  shareholder?: ShareholderExtendResponse | null;
}

const KycDetails = ({
  kycLoading,
  isKycDoneOutsideBronId,
  kycData,
  shareholder,
}: KycDetailsProps) => {
  const dataSet = useMemo(
    () => [
      { label: 'Registration Details', value: kycData?.name },
      { label: 'Request status', value: capitalize(kycData?.submission_status) },
      // { label: 'Bron Link', value: 'mock' },
      // { label: 'Created by', value: 'mock' },
      {
        label: 'Created date',
        value: dayjs(+(kycData?.timestamp || '0') * 1000).format('DD-MM-YYYY, HH:mm'),
      },
      // { label: 'Last modified by', value: 'mock' },
      // { label: 'Last modified date', value: 'mock' },
      { label: 'Verification status', value: capitalize(kycData?.verification_status) },
      { label: 'Risk Rating', value: kycData?.idvRiskScore?.description },
      // { label: 'Revised Risk Rating', value: 'mock' },
      // { label: 'On Watch List', value: 'mock' },
      { label: 'User ID', value: kycData?.user_id },
      { label: 'Verification ID', value: kycData?.verification_uuid },
    ],
    [kycData],
  );
  return (
    <InfoCard>
      {isKycDoneOutsideBronId ? (
        <div className="flex items-center justify-center h-24">
          <p className="font-semibold text-center">{getKycFallbackMessage(shareholder)}</p>
        </div>
      ) : (
        <InfoDetailsSet loading={kycLoading} set={dataSet} />
      )}
    </InfoCard>
  );
};

export default KycDetails;
